module.exports = __webpack_public_path__ + "static/roboto-v20-cyrillic_latin-regular-9af3b948743adc65907bf6b73aba735e.woff2";